export default __webpack_public_path__ + "static/media/thumbs-down.72318631.svg";